const products = [
  {
    name: "紅心火龍果",
    en: "Red Dragon Fruit",
    status: "現貨供應",
    statusColor: "bg-orange-100 text-orange-700",
    desc: "果肉鮮紅,甜度高,富含花青素和維生素C",
    spec: "規格:400-1000克/個",
    img: "https://public.readdy.ai/ai/img_res/e1f9468b2f1f9cdde3fa36d28572a317.jpg",
    featured: true,
  },
  {
    name: "黃皮火龍果",
    en: "Yellow Dragon Fruit",
    status: "現貨供應",
    statusColor: "bg-orange-100 text-orange-700",
    desc: "金黃皮膚,香甜多汁,纖維十足,越南獨有",
    spec: "規格:400-1000克/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20yellow%20dragon%20fruit%20with%20bright%20golden%20yellow%20skin%20and%20white%20flesh%20with%20black%20seeds%2C%20professional%20food%20photography%2C%20clean%20white%20background%2C%20natural%20lighting%20highlighting%20the%20rare%20tropical%20Vietnamese%20yellow%20pitaya%20fruit%20quality%20and%20vibrant%20color&width=600&height=700&seq=product-yellow-dragonfruit-002&orientation=portrait",
    featured: false,
  },
  {
    name: "金枕榴槤",
    en: "Monthong Durian",
    status: "預訂中",
    statusColor: "bg-amber-100 text-amber-700",
    desc: "果肉厚實,香味濃郁,口感綿密,榴槤之王",
    spec: "規格:2.5-4公斤/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20durian%20fruit%20with%20spiky%20shell%20partially%20opened%20showing%20creamy%20yellow%20flesh%2C%20professional%20food%20photography%2C%20clean%20white%20background%2C%20natural%20lighting%20highlighting%20the%20tropical%20fruit%20texture%20and%20quality&width=600&height=700&seq=product-durian-001&orientation=portrait",
    featured: false,
  },
  {
    name: "和祿芒果",
    en: "Hoa Loc Mango",
    status: "現貨供應",
    statusColor: "bg-orange-100 text-orange-700",
    desc: "越南經典品種,皮薄肉厚,甜度高達18-20°Brix,纖維極少,香氣馥郁",
    spec: "規格:450-800克/個",
    img: "https://readdy.ai/api/search-image?query=Hoa%20Loc%20Vietnamese%20mango%20variety%20with%20elongated%20oval%20shape%20smooth%20thin%20yellow%20green%20skin%20ripe%20tropical%20fruit%20arranged%20on%20clean%20white%20surface%20professional%20product%20food%20photography%20natural%20soft%20lighting%20showcasing%20the%20signature%20slender%20shape%20and%20vibrant%20color%20of%20Vietnam%20premium%20Hoa%20Loc%20mango%20variety&width=600&height=700&seq=product-hoaloc-mango-003&orientation=portrait",
    featured: false,
  },
  {
    name: "西瓜",
    en: "watermelon",
    status: "季節性供應",
    statusColor: "bg-purple-100 text-purple-700",
    desc: "越南無核西瓜，天然無籽，果肉鮮紅飽滿，甜度高達12°Brix，清甜多汁，食用方便無負擔",
    spec: "規格:4-5公斤/個",
    img: "https://public.readdy.ai/ai/img_res/edited_672b9c67f6ece8e835645ffc83e7f7e6_df84006d.jpg",
    featured: false,
  },
  {
    name: "青皮柚",
    en: "Green Pomelo",
    status: "現貨供應",
    statusColor: "bg-orange-100 text-orange-700",
    desc: "越南青皮柚，果皮翠綠清香，果肉飽滿多汁，甜中帶微酸，富含維生素C，清爽解膩",
    spec: "規格:1-2公斤/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20green%20pomelo%20fruit%20whole%20and%20cut%20open%20showing%20juicy%20pale%20yellow%20flesh%20segments%2C%20Vietnamese%20green%20skin%20pomelo%20on%20clean%20white%20background%2C%20professional%20food%20photography%2C%20natural%20lighting%20highlighting%20the%20thick%20green%20rind%20and%20translucent%20citrus%20flesh%2C%20tropical%20fruit%20quality%20showcase&width=600&height=700&seq=product-green-pomelo-001&orientation=portrait",
    featured: false,
  },
  {
    name: "百香果",
    en: "Passion Fruit",
    status: "現貨供應",
    statusColor: "bg-orange-100 text-orange-700",
    desc: "果香濃郁獨特,酸甜平衡,富含維生素A及C,果汁可直接飲用或調製飲品",
    spec: "規格:80-150克/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20ripe%20passion%20fruits%20whole%20and%20cut%20in%20half%20showing%20vibrant%20orange%20yellow%20pulp%20with%20black%20seeds%2C%20placed%20on%20clean%20white%20surface%2C%20professional%20food%20photography%2C%20natural%20soft%20lighting%2C%20simple%20minimalist%20background%20showcasing%20tropical%20Vietnamese%20passion%20fruit%20rich%20aroma%20and%20texture&width=600&height=700&seq=product-passionfruit-001&orientation=portrait",
    featured: false,
  },
  {
    name: "天桃",
    en: "Wax Apple",
    status: "季節性供應",
    statusColor: "bg-amber-100 text-amber-700",
    desc: "果皮鮮紅亮麗,口感清脆多汁,清甜爽口,富含水分,越南特色精品水果",
    spec: "規格:60-120克/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20Vietnamese%20wax%20apple%20fruit%20also%20known%20as%20java%20apple%20or%20bell%20fruit%2C%20bright%20deep%20red%20shiny%20skin%2C%20bell%20shaped%20tropical%20fruit%2C%20several%20whole%20fruits%20arranged%20on%20clean%20white%20background%2C%20professional%20food%20photography%2C%20natural%20soft%20lighting%20highlighting%20the%20glossy%20smooth%20red%20skin%20and%20fresh%20crisp%20texture%20of%20wax%20apple%2C%20premium%20quality%20tropical%20Vietnamese%20fruit%20showcase&width=600&height=700&seq=product-waxapple-tianto-001&orientation=portrait",
    featured: false,
  },
  {
    name: "山竹",
    en: "Mangosteen",
    status: "季節性供應",
    statusColor: "bg-amber-100 text-amber-700",
    desc: "被譽為「水果女王」,果肉潔白細嫩,甜酸適中,清香迷人,深受全球消費者喜愛",
    spec: "規格:80-150克/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20mangosteen%20fruits%20with%20deep%20purple%20rind%20whole%20and%20cut%20open%20revealing%20pure%20white%20segmented%20flesh%2C%20arranged%20on%20clean%20white%20background%2C%20professional%20food%20photography%2C%20natural%20lighting%20highlighting%20the%20smooth%20purple%20skin%20and%20creamy%20tropical%20flesh%20texture%2C%20premium%20quality%20tropical%20fruit&width=600&height=700&seq=product-mangosteen-001&orientation=portrait",
    featured: false,
  },
  {
    name: "番石榴",
    en: "Guava",
    status: "現貨供應",
    statusColor: "bg-orange-100 text-orange-700",
    desc: "果肉爽脆清甜,富含維生素C,是柑橘的5倍,越南特產無籽品種,食用方便",
    spec: "規格:200-500克/個",
    img: "https://readdy.ai/api/search-image?query=Fresh%20green%20guava%20fruit%20whole%20and%20cut%20in%20half%20showing%20crisp%20white%20pink%20flesh%2C%20Vietnamese%20seedless%20variety%20arranged%20on%20clean%20white%20surface%2C%20professional%20food%20photography%2C%20natural%20soft%20lighting%20highlighting%20the%20smooth%20green%20skin%20and%20dense%20tropical%20fruit%20flesh%20texture%2C%20healthy%20tropical%20fruit&width=600&height=700&seq=product-guava-001&orientation=portrait",
    featured: false,
  },
];

export default function ProductsSection() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="products" className="py-24 bg-gradient-to-b from-white to-amber-50" data-product-shop="true">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 gap-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight max-w-md">
            我們的
            <br />
            產品
          </h2>
          <p className="text-gray-600 max-w-xl">
            精選越南優質熱帶水果,每一顆都經過嚴格篩選,確保新鮮度和品質。我們提供多種規格包裝,滿足不同市場需求。
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p, i) => (
            <div
              key={i}
              onClick={scrollToContact}
              className={`group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer ${
                p.featured
                  ? "bg-gradient-to-br from-orange-700 to-orange-900 text-white"
                  : "bg-white"
              }`}
            >
              <div className="p-6 space-y-4">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className={`text-2xl font-bold ${p.featured ? "text-white" : "text-gray-900"}`}>
                      {p.name}
                    </h3>
                    <p className={`text-sm ${p.featured ? "text-orange-200" : "text-gray-500"}`}>{p.en}</p>
                  </div>
                  <span className={`px-3 py-1 text-xs font-medium rounded-full whitespace-nowrap ${p.statusColor}`}>
                    <span className="inline-block w-1.5 h-1.5 bg-current rounded-full mr-1.5"></span>
                    {p.status}
                  </span>
                </div>
                <div className="relative w-full h-64 rounded-xl overflow-hidden">
                  <img
                    alt={p.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    src={p.img}
                  />
                </div>
                <p className={`text-sm leading-relaxed ${p.featured ? "text-orange-100" : "text-gray-600"}`}>
                  {p.desc}
                </p>
                <div className="flex items-center justify-between pt-2">
                  <span className={`text-sm font-medium ${p.featured ? "text-orange-200" : "text-gray-500"}`}>
                    {p.spec}
                  </span>
                  <button
                    onClick={scrollToContact}
                    className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      p.featured
                        ? "bg-orange-600 text-white hover:bg-orange-500"
                        : "bg-orange-700 text-white hover:bg-orange-800"
                    }`}
                  >
                    即時聯絡
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
